export default "__VITE_ASSET__Dsci9NGE__"